const key = "logbookanaes.studio.device-id";

export function getDeviceId(): string {
  const existing = localStorage.getItem(key);
  if (existing) return existing;
  const created = `studio-${crypto.randomUUID()}`;
  localStorage.setItem(key, created);
  return created;
}

